import { BaseDesign, BaseSetup } from "./PlotTypes";
import { ValueTracker } from "../../pages/Visualization/MVCShared/types";
import styles from "../../styles.module.scss";

export interface ViolinSetup extends BaseSetup {
  // TODO: specifics
  bandwidth: ValueTracker<string>;
  custom: ValueTracker<number>;
  cut: ValueTracker<number>;
  gridSize: ValueTracker<number>;
  densityNorm: ValueTracker<string>;
  isCollapsed: boolean;
  xLim: boolean;
  yLim: boolean;
}

export interface ViolinDesign extends BaseDesign {
  // TODO: specifics
  width: ValueTracker<number>;
  saturation: ValueTracker<number>;
  lineWidth: ValueTracker<number>;
  split: ValueTracker<boolean>;
  dodge: ValueTracker<boolean>;
  violinInner: ValueTracker<string>;
  legendPosition: string;
  yticks: ValueTracker<number>;
  xticks: ValueTracker<number>;
  isCollapsed: boolean;
  alpha: ValueTracker<number>;
}

export const violinSetup: ViolinSetup = {
  headers: [],
  xAxis: "",
  yAxis: "",
  colorBy: "",
  orientation: new ValueTracker("Vertical"),
  bandwidth: new ValueTracker("Scott"),
  custom: new ValueTracker(0.1),
  cut: new ValueTracker(2),
  gridSize: new ValueTracker(100),
  densityNorm: new ValueTracker("Area"),
  isCollapsed: true,
  xLim: true,
  yLim: true,
};

export const violinDesign: ViolinDesign = {
  plotTitle: "",
  xAxisLabel: "",
  yAxisLabel: "",
  fill: new ValueTracker(true),
  color: new ValueTracker(styles.seabornDefault),
  palette: new ValueTracker("Tab10"),
  saturation: new ValueTracker(0.75),
  lineWidth: new ValueTracker(0),
  width: new ValueTracker(0.8),
  split: new ValueTracker(false),
  dodge: new ValueTracker(false),
  // true by default unless color by is selected otherwise set to false
  violinInner: new ValueTracker("Box"),
  legendPosition: "",
  yticks: new ValueTracker(0),
  xticks: new ValueTracker(0),
  isCollapsed: true,
  majorHorizontal: new ValueTracker(false),
  majorVertical: new ValueTracker(false),
  minorHorizontal: new ValueTracker(false),
  minorVertical: new ValueTracker(false),
  leftSpine: true,
  bottomSpine: true,
  topSpine: false,
  rightSpine: false,
  borderCollapsed: true,
  gridlinesCollapsed: true,
  alpha: new ValueTracker(1),
};
